/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {





  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        // add custom media query sizes for Foundation Interchange
        Foundation.Interchange.SPECIAL_QUERIES.smallretina = 'only screen and (min-width: 1px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1px) and (min-resolution: 192dpi), only screen and (min-width: 1px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.mediumretina = 'only screen and (min-width: 641px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 641px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 641px) and (min-device-pixel-ratio: 2), only screen and (min-width: 641px) and (min-resolution: 192dpi), only screen and (min-width: 641px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.largeretina = 'only screen and (min-width: 1025px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1025px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1025px) and (min-resolution: 192dpi), only screen and (min-width: 1025px) and (min-resolution: 2dppx)';
        Foundation.Interchange.SPECIAL_QUERIES.xlargeretina = 'only screen and (min-width: 1921px) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min--moz-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (-o-min-device-pixel-ratio: 2/1), only screen and (min-width: 1921px) and (min-device-pixel-ratio: 2), only screen and (min-width: 1921px) and (min-resolution: 192dpi), only screen and (min-width: 1921px) and (min-resolution: 2dppx)';

        // init Foundation JavaScript
        $(document).foundation();

        // add plz pattern for Foundation Abide
        Foundation.Abide.defaults.patterns.plz = /^([0]{1}[1-9]{1}|[1-9]{1}[0-9]{1})[0-9]{3}$/;

        // set default Sticky size for Foundation Sticky
        Foundation.Sticky.defaults.stickyOn = 'large';

        // Mobile Menu
        Foundation.DropdownMenu.defaults.closeOnClick = true;


        /*
          if ($('body').hasClass("home")) {
              $(".home .home-button a").prop("href", "https://disarmingdesign.com/about");
          }
          else {
              $(".home .home-button a").prop("href", "https://disarmingdesign.com/");
          }*/






          $('a[href="https://disarmingdesign.com/product/heirloom-seeds/"]').data( "barba-prevent", 'self' );



          $('.product-popup__close, .continue-shopping').on('click', function(e){
              $('.product-popup').removeClass('active');
          });




          $('.search__close').on("click", function(){
              $('.search-overlay').removeClass('active');
          });



          const buttons = document.querySelectorAll(".search-trigger");
          for (const button of buttons) {
              button.addEventListener('click', function(event) {
                  console.log('why-not-active?')
                  document.querySelector('.search-overlay').classList.add('active');
              })
          }









          $('.single_add_to_cart_button').on('click', function(e){

              $('.product-popup').addClass('active');


              e.preventDefault();



              $( '.mini-cart').removeClass("hidden");


              $thisbutton = $(this),

                  $form = $thisbutton.closest('form.cart'),

                  id = $thisbutton.val(),

                  product_qty = $form.find('input[name=quantity]').val() || 1,

                  product_id = $form.find('input[name=product_id]').val() || id,

                  variation_id = $form.find('input[name=variation_id]').val() || 0;

              var data = {

                  action: 'ql_woocommerce_ajax_add_to_cart',

                  product_id: product_id,

                  product_sku: '',

                  quantity: product_qty,

                  variation_id: variation_id,

              };

              $.ajax({

                  type: 'post',

                  url: wc_add_to_cart_params.ajax_url,

                  data: data,

                  beforeSend: function (response) {

                      $thisbutton.removeClass('added').addClass('loading');

                  },

                  complete: function (response) {

                      $thisbutton.addClass('added').removeClass('loading');

                  },

                  success: function (response) {

                      if (response.error & response.product_url) {

                          window.location = response.product_url;

                          return;

                      } else {

                          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

                      }

                  },

              });

          });


          $('.cat-list_item').on('click', function() {
              $('.cat-list_item').removeClass('active');
              $(this).addClass('active');

              $.ajax({
                  type: 'POST',
                  url: '/wp-admin/admin-ajax.php',
                  dataType: 'html',
                  data: {
                      action: 'filter_projects',
                      category: $(this).data('slug'),
                  },
                  success: function(res) {
                      $('.project-tiles').html(res);
                  }
              })
          });



          var slides = document.querySelectorAll('.slide');
          var currentSlide = 0;
          var slideInterval = setInterval(nextSlide,5000);

          function nextSlide(){
              slides[currentSlide].className = 'slide';
              currentSlide = (currentSlide+1)%slides.length;
              slides[currentSlide].className = 'slide showing';
          }


          var slides_p = document.querySelectorAll('.slide-p');
          var currentSlide_p = 0;
          var slideInterval_p = setInterval(nextSlide_p,5000);

          function nextSlide_p(){
              slides_p[currentSlide_p].className = 'slide-p';
              currentSlide_p = (currentSlide_p+1)%slides_p.length;
              slides_p[currentSlide_p].className = 'slide-p showing';
          }


          var slides_a = document.querySelectorAll('.slide-a');
          var currentSlide_a = 0;
          var slideInterval_a = setInterval(nextSlide_a,5000);

          function nextSlide_a(){
              slides_a[currentSlide_a].className = 'slide-a';
              currentSlide_a = (currentSlide_a+1)%slides_a.length;
              slides_a[currentSlide_a].className = 'slide-a showing';
          }





          function about_nav() {
              $(".left-about-nav a").click(function (event) {

                  event.preventDefault();
                  navto = $($(this).attr("href")).offset().top + $('.left-about').scrollTop() - 60;

                  if ($($(this).attr("href")).offset().top != 20) { //prevent scroll to current link
                      $('.left-about').animate({
                              scrollTop: navto
                          }, 800
                      );
                  }

              });

              $(".right-about-nav a").click(function (event) {

                  event.preventDefault();
                  navto2 = $($(this).attr("href")).offset().top + $('.right-about').scrollTop() - 50;

                  if ($($(this).attr("href")).offset().top != 20) { //prevent scroll to current link
                      $('.right-about').animate({
                              scrollTop: navto2
                          }, 800
                      );
                  }

              });

              $(".left-about").on("scroll", onScroll);

              function onScroll(event) {
                  var scrollPosition = $('.left-about').scrollTop() + 60;

                  // set your navigation a class name
                  $('.left-about-nav a').each(function () {
                      var currentLink = $(this);
                      var refElement = $(currentLink.attr("href"));
                      if ((refElement.position().top + $('.left-about').scrollTop()) <= scrollPosition && (refElement.position().top + $('.left-about').scrollTop()) + refElement.height() > scrollPosition) {
                          $('.left-about-nav a').removeClass("active");
                          currentLink.addClass("active");
                      } else {
                          currentLink.removeClass("active");
                      }
                  });
              }

              $(".right-about").on("scroll", onScroll2);

              function onScroll2(event) {
                  var scrollPosition2 = $('.right-about').scrollTop() + 60;

                  // set your navigation a class name
                  $('.right-about-nav a').each(function () {
                      var currentLink2 = $(this);
                      var refElement2 = $(currentLink2.attr("href"));
                      if ((refElement2.position().top + $('.right-about').scrollTop()) <= scrollPosition2 && (refElement2.position().top + $('.right-about').scrollTop()) + refElement2.height() > scrollPosition2) {
                          $('.right-about-nav a').removeClass("active");
                          currentLink2.addClass("active");
                      } else {
                          currentLink2.removeClass("active");
                      }
                  });
              }

          }

        // change body class on scroll
        $(window).scroll(function() {
          if ($(this).scrollTop() > 50) {
            $('body').addClass('solid-header');
          } else {
            $('body').removeClass('solid-header');
          }
        });

        // add no-touch class for desktop browsers
        var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        if (!touchsupport) {
            document.documentElement.className += " no-touch ";
        }


          $('.slider-normal-bottom').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            pauseOnHover: false,
            fade: true,
            lazyLoad: 'ondemand',
            speed: 2500,
            //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            autoplaySpeed: 4500,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  speed: 700
                }
              }
            ]
          });




        $('.slider-normal-top').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          pauseOnHover: false,
          fade: true,
          lazyLoad: 'ondemand',
          speed: 2500,
          //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
          autoplaySpeed: 4000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700
              }
            }
          ]
        });

          

        $('.slider-default').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
          pauseOnHover: true,
          //fade: true,
          speed: 500,
          //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
          //autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });



        /*$('.slider-row').slickLightbox({
          itemSelector        : 'a',
          navigateByKeyboard  : true
        });*/


        $('.slider-row').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: true,
          dots: false,
          adaptiveHeight: true,
          autoplay: false,
          pauseOnHover: false,
          fade: false,
          customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<span class="normal">'+(i+1)+'</span>';
          },
          responsive: [
              {
                  breakpoint: 1280,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3
                  }
              },
              {
                  breakpoint: 992,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      //rows: 4
                  }
              }
          ]
        });


          $('.slider-row-home').slick({
              slidesToShow: 4,
              slidesToScroll: 4,
              arrows: true,
              dots: false,
              adaptiveHeight: true,
              autoplay: false,
              pauseOnHover: false,
              fade: false,
              customPaging : function(slider, i) {
                  var thumb = $(slider.$slides[i]).data();
                  return '<span class="normal">'+(i+1)+'</span>';
              },
              responsive: [
                  {
                      breakpoint: 1280,
                      settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3
                      }
                  },
                  {
                      breakpoint: 992,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2
                      }
                  },
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                      }
                  }
              ]
          });



        var numSlides = $('.slick-dots li').length;
        $( ".slick-dots li:last-child" ).after( '<span class="total"> / '+ numSlides +'</span>' );
        $('.slick-prev').appendTo(".slick-dots");
        $('.slick-next').appendTo(".slick-dots");


          $('.slider-gif').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            fade: true,
            speed: 0,
            pauseOnHover: false,
            autoplaySpeed: 500
          });


        $('.slider-autoplay').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: true,
          pauseOnHover: false,
          fade: true,
          autoplaySpeed: 1000
        });


        $(".wpcf7-submit").click(function() {
          $('html,body').animate({
                scrollTop: $(".wpcf7").offset().top - 90},
              'fast');
        });

       // document.addEventListener( 'wpcf7mailsent', function( event ) {
        //   $(".section-inner").find('h1').hide();
        //  $(".section-inner").find('p').hide();
       //   $(".section-inner").find(".shadow").css("border", "none !important");
      //    $(".section-inner").find(".shadow").css("box-shadow", "none");
      //  }, false );

          $('.projects-link-footer .a').click(function() {
              $('.projects-link-footer').addClass('active');

          });











      setTimeout(function() {
        $('.woocommerce-message').fadeOut('fast') 
    }, 5000);


        $(window).scroll(function(){
          if ($(window).scrollTop() >= 100) {
            $('.fixed-header').addClass('fixed-visible');
          }
          else {
            $('.fixed-header').removeClass('fixed-visible');
          }
        });

        if ($(window).scrollTop() >= 100) {
          $('.fixed-header').addClass('fixed-visible');
        }
        else {
          $('.fixed-header').removeClass('fixed-visible');
        }

        $(".project-menu-trigger").click(function(){
          $(".project-list").toggleClass("active");
        });

        $(".about-menu-trigger").click(function(){
          $(".left-about-nav").toggleClass("active");
        });

        

        $(".trigger-mobile-menu").click(function(){
          $(".mobile-menu").addClass("show-mobile-menu");
          $(".body-overlay").show("fast");
        });

        $(".close-mobile-menu, .body-overlay, .close-wrapper svg").click(function(){
          $(".mobile-menu").removeClass("show-mobile-menu");
          $(".body-overlay").hide("fast");
      
        });

       /*   $('.wpcf7-date').datepicker();

          $('.wpcf7-date').focus(function(){
            $('.wpcf7-date').datepicker('show');
          });

          $('.wpcf7-date').click(function(){
            $('.wpcf7-date').datepicker('show');
          });
//$('#ui-datepicker-div').show();
          $('.wpcf7-date').datepicker('show');



        $('.wpcf7-date').focus(function(){
          $('.wpcf7-date').datepicker('show');
        });

*/








        // Form validation
        $(".standard-form").bind("submit",function(e) {
          e.preventDefault();
          console.log("submit intercepted");
          return false;
        });
        $(".standard-form").bind("invalid.zf.abide", function(ev,elem) {
          console.log("Field "+elem.attr('name')+" is invalid");
          var errorCount = $(this).find('[data-invalid]').length;
          if (errorCount===0) {
            $("#error-message").hide();
          }
        });
        $(".standard-form").bind("valid.zf.abide", function(ev,elem) {
          console.log("Field "+elem.attr('name')+" is valid");
          var errorCount = $(this).find('[data-invalid]').length;
          if (errorCount!==0) {
            $("#error-message").show();
            $("#error-count").html(errorCount);
          } else {
            $("#error-message").hide();
          }
        });
        $(".standard-form").bind("forminvalid.zf.abide", function(e,target) {
          console.log("form is invalid");
        });
        $(".standard-form").bind("formvalid.zf.abide", function(e,target) {
          console.log("form is valid");
          var formData = 'action=standardFormAction&post_id=' + my_ajax_object.post_id + '&' + $(this).serialize();

          $.ajax({
            url: my_ajax_object.ajax_url, // Let WordPress figure this url out...
            type: 'POST',
            dataType: 'JSON', // Set this so we don't need to decode the response...
            data: formData, // One-liner form data prep...
            beforeSend: function () {
              // You could do an animation here...
            },
            error: function () {
              console.log('error function fired');
            },
            success: function (data) {
              console.log(data.status);
              $("#ajaxoutput").html(data);
              if (data.status === 'success') {
                $(".standard-form").hide();
                $('#thank-you-message').fadeIn(300);
                $(window).trigger('resize');
              } else {
                console.log('success error');
              }
            },
            complete: function() {
              //console.log('Complete');
            }
          });
          return false;
        });


          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 1) {
                  $(this).css('justify-content','center');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 2) {
                  $(this).css('justify-content','center');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 5) {
                  $(this).css('justify-content','start');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 8) {
                  $(this).css('justify-content','start');
              }
          });

          $('.teaser-boxes').each(function () {
              if ( $(this).children().length == 11) {
                  $(this).css('justify-content','start');
              }
          });



  



     





        // Toggle menu
        $('[data-off-canvas]').on("opened.zf.offcanvas", function(e) {
          $('#toggle-menu').addClass('open');
          $('#main-header').addClass('toggle-menu-open');
          $('body').addClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').addClass('active');
        });
        $('[data-off-canvas]').on("closed.zf.offcanvas", function(e) {
          $('#toggle-menu').removeClass('open');
          $('#main-header').removeClass('toggle-menu-open');
          $('body').removeClass('no-scroll toggle-menu-open');
          $('#toggle-menu-button').removeClass('active');
        });

        $('#toggle-menu .menu-item-has-children > a').click(function(){
           var i = 0;
           var parent = $(this).parent();
           $('#toggle-menu ul > li').each(function(){
             if($('#toggle-menu ul > li').index(parent)!==i){
               $(this).removeClass('open');
               $(this).find('*').removeClass('open');
             }
             i++;
           });
           $(this).parent().toggleClass('open');
           $(this).toggleClass('open');
           $(this).siblings('.foldable-content').toggleClass('open');
           return false;
        });

        // Smooth scrolling
        if(window.location.hash) {
          $('html, body').animate({
              scrollTop: $(window.location.hash).offset().top - $('header').height() + 'px'
          }, 1000);
        }

        // Scrolldown Button scrolling
        $('.scrolldown-button').click(function(){
          var nextSection = $(this).closest('section').next();

          $('html, body').animate({
              scrollTop: nextSection.offset().top
          }, 1000);
        });

        function equalHeight(group) {
          var tallest = 0;
          group.css('height','auto'); //otherwise only works once!
          group.each(function() {
            var thisHeight = $(this).height();
            if(thisHeight > tallest) {
              tallest = thisHeight;
            }
          });
          group.height(tallest);
        }

















        if (window.location.href.indexOf("?add-to-cart=3400") > -1) {
          $(".notice-15").show().delay(5000).fadeOut();
      }

      if (window.location.href.indexOf("?add-to-cart=3401") > -1) {
        $(".notice-30").show().delay(5000).fadeOut();
    }


    if (window.location.href.indexOf("?add-to-cart=3403") > -1) {
      $(".notice-50").show().delay(5000).fadeOut();
  }



    

  




  

         // langmenu
         $(".about-trigger, .contact-trigger, .menu-item-3459 a").on("click", function(){
          $("#footer-wrap").toggleClass("active");
          $("#footer-wrap .close").toggleClass("active");
        });


        $(".woo-home, .header-section, .left-bar-left ").on("click", function(){
          $("#footer-wrap").removeClass("active");
        });

      


          // langmenu
            $(".dropdown-lang").on("click", function(){
            $(".lang-menu, .dropdown-lang i, .dropdown-lang, .lang-menu-bg").toggleClass("active");
            $("body, html").toggleClass("noscroll");
          });

          $(".lang-menu-bg").on("click", function(){
              $(".lang-menu, .dropdown-lang i, .dropdown-lang, .lang-menu-bg").removeClass("active");
            $("body, html").removeClass("noscroll");
          });

        $(".close-button, .icon-close").on("click", function(){
          $(".lang-menu, .dropdown-lang i, .dropdown-lang, .lang-menu-bg").removeClass("active");
          $("body, html").removeClass("noscroll");
        });

// Arrow Down Scroll
        $(document).on('click', '.arrow-down', function(event){
          event.preventDefault();
          var viewportHeight = $(window).height();

          $('html, body').animate({
            scrollTop: viewportHeight + 10,
            complete: function () {
              //Hide your button here
            }
          }, 700);
        });

        // ie object-fit fallback
        function checkForIE() {
          var userAgent = window.navigator.userAgent;
          var ieReg = /msie|Trident.*rv[ :]*11\./gi;
          var ie = ieReg.test(userAgent);


          if(ie) {
            $(".image-wrap").each(function () {
              var $container = $(this);
              var imgUrl = $container.find("img").prop("src");
              var imgPos = $container.find("img").attr("data-object-position");
              if (imgUrl) {
                $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("ie-object-fit");
                if (imgPos) {
                  $container.css("background-position", imgPos);
                }
              }
            });
          }
        }
        checkForIE();



        $(".woocommerce div.product").addClass("slide-in");
        $(".project-single-wrapper").addClass("slide-in");




        if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
          $(".events-video-wrapper video").hide();
          $(".events-video-wrapper .video-thumbnail").show();
        }
        else {
          $(".events-video-wrapper video").show();
          $(".events-video-wrapper .video-thumbnail").hide();
        }


        $('.project-list li a').on("click",function(){
          $(window).scrollTop(0);
        });



        

       /* $('.link-to-artwork').click(function() {
          window.history.pushState('obj', 'newtitle', '/abc');
          return false;
       });*/


       /*
          ( function( $ ) {
         
            $( function() {
             
                var settings = { 
               
                    onStart: {
                        duration: 280, // ms
                        render: function ( $container ) {
                            $container.addClass( 'slide-out' );
                        }
                    },
                    onAfter: function( $container ) {
                        prep();
                        $container.removeClass( 'slide-out' );
                    }
                };
         
                $( '#smooth' ).smoothState( settings );
            } );
         
        })( jQuery );

        $('#smooth').smoothState({
          onAfter: function() {
            alert("test");
            prep();
          }
        });
*/


/*
        function prep(){

          alert("test");
    
    } // prep





*/

        barba.use(barbaCss);
        barba.init({
            timeout: 10000,




          transitions: [
              {
                  name: 'slide-p',
                  beforeLeave: () => {
                  },
                  leave: function (data) {
                  },
                  enter: function (data) {

                  },
                  afterEnter: function (data) {


                      const buttons = document.querySelectorAll(".search-trigger");
                      for (const button of buttons) {
                          button.addEventListener('click', function(event) {
                              console.log('why-not-active?')
                              document.querySelector('.search-overlay').classList.add('active');
                          })
                      }



                      $('.search__close').on("click", function(){
                          $('.search-overlay').removeClass('active');
                      });



                      
                      



                      setTimeout(function() {
                          $('.products-link-footer').addClass('active-phase-1');
                      }, 300);

                      setTimeout(function() {
                          $('.products-link-footer').removeClass('active');
                          $('.products-link-footer').addClass('active-phase-2');
                      }, 300);

                      setTimeout(function() {
                          $('.products-link-footer').removeClass('active');
                          $('.products-link-footer').removeClass('active-phase-1');
                          $('.products-link-footer').removeClass('active-phase-2');
                          $('.projects-link-footer').removeClass('active');
                          $('.projects-link-footer').removeClass('active-phase-1');
                          $('.projects-link-footer').removeClass('active-phase-2');
                      }, 400);
                  },
                  from: {
                      namespace: 'projects-page'
                  },
                  to: {
                      namespace: 'shop-page'
                  }
              },
              {
                  name: 'slide-s',
                  beforeLeave: () => {
                  },
                  leave: function (data) {
                  },
                  enter: function (data) {

                  },

                  afterEnter: function (data) {


                      $('.slider-row').slick({
                          slidesToShow: 4,
                          slidesToScroll: 4,
                          arrows: true,
                          dots: false,
                          adaptiveHeight: true,
                          autoplay: false,
                          pauseOnHover: false,
                          fade: false,
                          customPaging : function(slider, i) {
                              var thumb = $(slider.$slides[i]).data();
                              return '<span class="normal">'+(i+1)+'</span>';
                          },
                          responsive: [
                              {
                                  breakpoint: 1280,
                                  settings: {
                                      slidesToShow: 3,
                                      slidesToScroll: 3
                                  }
                              },
                              {
                                  breakpoint: 992,
                                  settings: {
                                      slidesToShow: 2,
                                      slidesToScroll: 2
                                  }
                              },
                              {
                                  breakpoint: 768,
                                  settings: {
                                      slidesToShow: 1,
                                      slidesToScroll: 1,
                                      //rows: 4
                                  }
                              }
                          ]
                      });




                      setTimeout(function() {
                          $('.projects-link-footer').addClass('active-phase-1');
                      }, 200);


                      setTimeout(function() {
                          $('.projects-link-footer').removeClass('active');
                          $('.projects-link-footer').addClass('active-phase-2');
                      }, 300);

                      setTimeout(function() {
                          $('.projects-link-footer').removeClass('active');
                          $('.projects-link-footer').removeClass('active-phase-1');
                          $('.projects-link-footer').removeClass('active-phase-2');
                          $('.products-link-footer').removeClass('active');
                          $('.products-link-footer').removeClass('active-phase-1');
                          $('.products-link-footer').removeClass('active-phase-2');
                      }, 400);

                  },



                  from: {
                      namespace: 'shop-page'
                  },
                  to: {
                      namespace: 'projects-page'
                  }
              },
            {

              beforeLeave: function (data) {


              },

              beforeEnter: function (data) {
                $('.project__navigation').addClass('hidden');
                  $('.product-popup').removeClass('active');
                  $('.search-overlay').removeClass('active');








              },
              afterEnter: function (data) {

              },


              leave: function (data) {
              },
              enter: function (data) {
              },
            },
          ],
        },


        );









        barba.hooks.afterLeave((data) => {
          // Set <body> classes for "next" page
          var nextHtml = data.next.html;
          var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml);
          var bodyClasses = $(response).filter('notbody').attr('class');
          $("body").attr("class", bodyClasses);

            !function(y,c,i,n){var t=function(t){var a=this;a.$form=t,a.$attributeFields=t.find(".variations select"),a.$singleVariation=t.find(".single_variation"),a.$singleVariationWrap=t.find(".single_variation_wrap"),a.$resetVariations=t.find(".reset_variations"),a.$product=t.closest(".product"),a.variationData=t.data("product_variations"),a.useAjax=!1===a.variationData,a.xhr=!1,a.loading=!0,a.$singleVariationWrap.show(),a.$form.off(".wc-variation-form"),a.getChosenAttributes=a.getChosenAttributes.bind(a),a.findMatchingVariations=a.findMatchingVariations.bind(a),a.isMatch=a.isMatch.bind(a),a.toggleResetLink=a.toggleResetLink.bind(a),t.on("click.wc-variation-form",".reset_variations",{variationForm:a},a.onReset),t.on("reload_product_variations",{variationForm:a},a.onReload),t.on("hide_variation",{variationForm:a},a.onHide),t.on("show_variation",{variationForm:a},a.onShow),t.on("click",".single_add_to_cart_button",{variationForm:a},a.onAddToCart),t.on("reset_data",{variationForm:a},a.onResetDisplayedVariation),t.on("reset_image",{variationForm:a},a.onResetImage),t.on("change.wc-variation-form",".variations select",{variationForm:a},a.onChange),t.on("found_variation.wc-variation-form",{variationForm:a},a.onFoundVariation),t.on("check_variations.wc-variation-form",{variationForm:a},a.onFindVariation),t.on("update_variation_values.wc-variation-form",{variationForm:a},a.onUpdateAttributes),setTimeout(function(){t.trigger("check_variations"),t.trigger("wc_variation_form",a),a.loading=!1},100)};t.prototype.onReset=function(t){t.preventDefault(),t.data.variationForm.$attributeFields.val("").trigger("change"),t.data.variationForm.$form.trigger("reset_data")},t.prototype.onReload=function(t){t=t.data.variationForm;t.variationData=t.$form.data("product_variations"),t.useAjax=!1===t.variationData,t.$form.trigger("check_variations")},t.prototype.onHide=function(t){t.preventDefault(),t.data.variationForm.$form.find(".single_add_to_cart_button").removeClass("wc-variation-is-unavailable").addClass("disabled wc-variation-selection-needed"),t.data.variationForm.$form.find(".woocommerce-variation-add-to-cart").removeClass("woocommerce-variation-add-to-cart-enabled").addClass("woocommerce-variation-add-to-cart-disabled")},t.prototype.onShow=function(t,a,i){t.preventDefault(),i?(t.data.variationForm.$form.find(".single_add_to_cart_button").removeClass("disabled wc-variation-selection-needed wc-variation-is-unavailable"),t.data.variationForm.$form.find(".woocommerce-variation-add-to-cart").removeClass("woocommerce-variation-add-to-cart-disabled").addClass("woocommerce-variation-add-to-cart-enabled")):(t.data.variationForm.$form.find(".single_add_to_cart_button").removeClass("wc-variation-selection-needed").addClass("disabled wc-variation-is-unavailable"),t.data.variationForm.$form.find(".woocommerce-variation-add-to-cart").removeClass("woocommerce-variation-add-to-cart-enabled").addClass("woocommerce-variation-add-to-cart-disabled")),wp.mediaelement&&t.data.variationForm.$form.find(".wp-audio-shortcode, .wp-video-shortcode").not(".mejs-container").filter(function(){return!y(this).parent().hasClass("mejs-mediaelement")}).mediaelementplayer(wp.mediaelement.settings)},t.prototype.onAddToCart=function(t){y(this).is(".disabled")&&(t.preventDefault(),y(this).is(".wc-variation-is-unavailable")?c.alert(wc_add_to_cart_variation_params.i18n_unavailable_text):y(this).is(".wc-variation-selection-needed")&&c.alert(wc_add_to_cart_variation_params.i18n_make_a_selection_text))},t.prototype.onResetDisplayedVariation=function(t){t=t.data.variationForm;t.$product.find(".product_meta").find(".sku").wc_reset_content(),t.$product.find(".product_weight, .woocommerce-product-attributes-item--weight .woocommerce-product-attributes-item__value").wc_reset_content(),t.$product.find(".product_dimensions, .woocommerce-product-attributes-item--dimensions .woocommerce-product-attributes-item__value").wc_reset_content(),t.$form.trigger("reset_image"),t.$singleVariation.slideUp(200).trigger("hide_variation")},t.prototype.onResetImage=function(t){t.data.variationForm.$form.wc_variations_image_update(!1)},t.prototype.onFindVariation=function(t,a){var i=t.data.variationForm,e=void 0!==a?a:i.getChosenAttributes(),a=e.data;e.count&&e.count===e.chosenCount?i.useAjax?(i.xhr&&i.xhr.abort(),i.$form.block({message:null,overlayCSS:{background:"#fff",opacity:.6}}),a.product_id=parseInt(i.$form.data("product_id"),10),a.custom_data=i.$form.data("custom_data"),i.xhr=y.ajax({url:wc_add_to_cart_variation_params.wc_ajax_url.toString().replace("%%endpoint%%","get_variation"),type:"POST",data:a,success:function(t){t?i.$form.trigger("found_variation",[t]):(i.$form.trigger("reset_data"),e.chosenCount=0,i.loading||(i.$form.find(".single_variation").after('<p class="wc-no-matching-variations woocommerce-info">'+wc_add_to_cart_variation_params.i18n_no_matching_variations_text+"</p>"),i.$form.find(".wc-no-matching-variations").slideDown(200)))},complete:function(){i.$form.unblock()}})):(i.$form.trigger("update_variation_values"),(a=i.findMatchingVariations(i.variationData,a).shift())?i.$form.trigger("found_variation",[a]):(i.$form.trigger("reset_data"),e.chosenCount=0,i.loading||(i.$form.find(".single_variation").after('<p class="wc-no-matching-variations woocommerce-info">'+wc_add_to_cart_variation_params.i18n_no_matching_variations_text+"</p>"),i.$form.find(".wc-no-matching-variations").slideDown(200)))):(i.$form.trigger("update_variation_values"),i.$form.trigger("reset_data")),i.toggleResetLink(0<e.chosenCount)},t.prototype.onFoundVariation=function(t,a){var i=t.data.variationForm,e=i.$product.find(".product_meta").find(".sku"),r=i.$product.find(".product_weight, .woocommerce-product-attributes-item--weight .woocommerce-product-attributes-item__value"),o=i.$product.find(".product_dimensions, .woocommerce-product-attributes-item--dimensions .woocommerce-product-attributes-item__value"),n=i.$singleVariationWrap.find(".quantity"),s=!0,c=!1,t="";a.sku?e.wc_set_content(a.sku):e.wc_reset_content(),a.weight?r.wc_set_content(a.weight_html):r.wc_reset_content(),a.dimensions?o.wc_set_content(y.parseHTML(a.dimensions_html)[0].data):o.wc_reset_content(),i.$form.wc_variations_image_update(a),a.variation_is_visible?(c=_("variation-template"),a.variation_id):c=_("unavailable-variation-template"),t=(t=(t=c({variation:a})).replace("/*<![CDATA[*/","")).replace("/*]]>*/",""),i.$singleVariation.html(t),i.$form.find('input[name="variation_id"], input.variation_id').val(a.variation_id).trigger("change"),"yes"===a.is_sold_individually?(n.find("input.qty").val("1").attr("min","1").attr("max","").trigger("change"),n.hide()):(c=n.find("input.qty"),t=parseFloat(c.val()),t=isNaN(t)||(t=t>parseFloat(a.max_qty)?a.max_qty:t)<parseFloat(a.min_qty)?a.min_qty:t,c.attr("min",a.min_qty).attr("max",a.max_qty).val(t).trigger("change"),n.show()),a.is_purchasable&&a.is_in_stock&&a.variation_is_visible||(s=!1),(i.$singleVariation.text().trim()?i.$singleVariation.slideDown(200):i.$singleVariation.show()).trigger("show_variation",[a,s])},t.prototype.onChange=function(t){t=t.data.variationForm;t.$form.find('input[name="variation_id"], input.variation_id').val("").trigger("change"),t.$form.find(".wc-no-matching-variations").remove(),t.useAjax||t.$form.trigger("woocommerce_variation_select_change"),t.$form.trigger("check_variations"),t.$form.trigger("woocommerce_variation_has_changed")},t.prototype.addSlashes=function(t){return t=(t=t.replace(/'/g,"\\'")).replace(/"/g,'\\"')},t.prototype.onUpdateAttributes=function(t){var b=t.data.variationForm,$=b.getChosenAttributes().data;b.useAjax||(b.$attributeFields.each(function(t,a){var i=y(a),e=i.data("attribute_name")||i.attr("name"),r=y(a).data("show_option_none"),o=":gt(0)",a=0,n=y("<select/>"),s=i.val()||"",c=!0;i.data("attribute_html")||((_=i.clone()).find("option").prop("disabled attached",!1).prop("selected",!1),i.data("attribute_options",_.find("option"+o).get()),i.data("attribute_html",_.html())),n.html(i.data("attribute_html"));var _=y.extend(!0,{},$);_[e]="";var d,m=b.findMatchingVariations(b.variationData,_);for(d in m)if("undefined"!=typeof m[d]){var l,v=m[d].attributes;for(l in v)if(v.hasOwnProperty(l)){var g=v[l],u="";if(l===e)if(m[d].variation_is_active&&(u="enabled"),g){g=y("<div/>").html(g).text();var f=n.find("option");if(f.length)for(var h=0,p=f.length;h<p;h++){var w=y(f[h]);if(g===w.val()){w.addClass("attached "+u);break}}}else n.find("option:gt(0)").addClass("attached "+u)}}a=n.find("option.attached").length,s&&(c=!1,0!==a&&n.find("option.attached.enabled").each(function(){var t=y(this).val();if(s===t)return!(c=!0)})),0<a&&s&&c&&"no"===r&&(n.find("option:first").remove(),o=""),n.find("option"+o+":not(.attached)").remove(),i.html(n.html()),i.find("option"+o+":not(.enabled)").prop("disabled",!0),s?c?i.val(s):i.val("").trigger("change"):i.val("")}),b.$form.trigger("woocommerce_update_variation_values"))},t.prototype.getChosenAttributes=function(){var i={},e=0,r=0;return this.$attributeFields.each(function(){var t=y(this).data("attribute_name")||y(this).attr("name"),a=y(this).val()||"";0<a.length&&r++,e++,i[t]=a}),{count:e,chosenCount:r,data:i}},t.prototype.findMatchingVariations=function(t,a){for(var i=[],e=0;e<t.length;e++){var r=t[e];this.isMatch(r.attributes,a)&&i.push(r)}return i},t.prototype.isMatch=function(t,a){var i,e,r,o=!0;for(i in t){t.hasOwnProperty(i)&&(e=t[i],r=a[i],e!==n&&r!==n&&0!==e.length&&0!==r.length&&e!==r&&(o=!1))}return o},t.prototype.toggleResetLink=function(t){t?"hidden"===this.$resetVariations.css("visibility")&&this.$resetVariations.css("visibility","visible").hide().fadeIn():this.$resetVariations.css("visibility","hidden")},y.fn.wc_variation_form=function(){return new t(this),this},y.fn.wc_set_content=function(t){n===this.attr("data-o_content")&&this.attr("data-o_content",this.text()),this.text(t)},y.fn.wc_reset_content=function(){n!==this.attr("data-o_content")&&this.text(this.attr("data-o_content"))},y.fn.wc_set_variation_attr=function(t,a){n===this.attr("data-o_"+t)&&this.attr("data-o_"+t,this.attr(t)?this.attr(t):""),!1===a?this.removeAttr(t):this.attr(t,a)},y.fn.wc_reset_variation_attr=function(t){n!==this.attr("data-o_"+t)&&this.attr(t,this.attr("data-o_"+t))},y.fn.wc_maybe_trigger_slide_position_reset=function(t){var a=y(this),i=a.closest(".product").find(".images"),e=!1,t=t&&t.image_id?t.image_id:"";a.attr("current-image")!==t&&(e=!0),a.attr("current-image",t),e&&i.trigger("woocommerce_gallery_reset_slide_position")},y.fn.wc_variations_image_update=function(t){var a=this,i=a.closest(".product"),e=i.find(".images"),r=i.find(".flex-control-nav"),o=r.find("li:eq(0) img"),n=e.find(".woocommerce-product-gallery__image, .woocommerce-product-gallery__image--placeholder").eq(0),s=n.find(".wp-post-image"),i=n.find("a").eq(0);if(t&&t.image&&t.image.src&&1<t.image.src.length){0<r.find('li img[data-o_src="'+t.image.gallery_thumbnail_src+'"]').length&&a.wc_variations_image_reset();r=r.find('li img[src="'+t.image.gallery_thumbnail_src+'"]');if(0<r.length)return r.trigger("click"),a.attr("current-image",t.image_id),void c.setTimeout(function(){y(c).trigger("resize"),e.trigger("woocommerce_gallery_init_zoom")},20);s.wc_set_variation_attr("src",t.image.src),s.wc_set_variation_attr("height",t.image.src_h),s.wc_set_variation_attr("width",t.image.src_w),s.wc_set_variation_attr("srcset",t.image.srcset),s.wc_set_variation_attr("sizes",t.image.sizes),s.wc_set_variation_attr("title",t.image.title),s.wc_set_variation_attr("data-caption",t.image.caption),s.wc_set_variation_attr("alt",t.image.alt),s.wc_set_variation_attr("data-src",t.image.full_src),s.wc_set_variation_attr("data-large_image",t.image.full_src),s.wc_set_variation_attr("data-large_image_width",t.image.full_src_w),s.wc_set_variation_attr("data-large_image_height",t.image.full_src_h),n.wc_set_variation_attr("data-thumb",t.image.src),o.wc_set_variation_attr("src",t.image.gallery_thumbnail_src),i.wc_set_variation_attr("href",t.image.full_src)}else a.wc_variations_image_reset();c.setTimeout(function(){y(c).trigger("resize"),a.wc_maybe_trigger_slide_position_reset(t),e.trigger("woocommerce_gallery_init_zoom")},20)},y.fn.wc_variations_image_reset=function(){var t=this.closest(".product"),a=t.find(".images"),i=t.find(".flex-control-nav").find("li:eq(0) img"),e=a.find(".woocommerce-product-gallery__image, .woocommerce-product-gallery__image--placeholder").eq(0),t=e.find(".wp-post-image"),a=e.find("a").eq(0);t.wc_reset_variation_attr("src"),t.wc_reset_variation_attr("width"),t.wc_reset_variation_attr("height"),t.wc_reset_variation_attr("srcset"),t.wc_reset_variation_attr("sizes"),t.wc_reset_variation_attr("title"),t.wc_reset_variation_attr("data-caption"),t.wc_reset_variation_attr("alt"),t.wc_reset_variation_attr("data-src"),t.wc_reset_variation_attr("data-large_image"),t.wc_reset_variation_attr("data-large_image_width"),t.wc_reset_variation_attr("data-large_image_height"),e.wc_reset_variation_attr("data-thumb"),i.wc_reset_variation_attr("src"),a.wc_reset_variation_attr("href")},y(function(){"undefined"!=typeof wc_add_to_cart_variation_params&&y(".variations_form").each(function(){y(this).wc_variation_form()})});var _=function(t){var a=i.getElementById("tmpl-"+t).textContent;return/<#\s?data\./.test(a)||/{{{?\s?data\.(?!variation\.).+}}}?/.test(a)||/{{{?\s?data\.variation\.[\w-]*[^\s}]/.test(a)?wp.template(t):function(t){var r=t.variation||{};return a.replace(/({{{?)\s?data\.variation\.([\w-]*)\s?(}}}?)/g,function(t,a,i,e){if(a.length!==e.length)return"";i=r[i]||"";return 2===a.length?c.escape(i):i})}}}(jQuery,window,document);


        });

          barba.hooks.enter(({next}) => {




              let js = document.querySelectorAll('script.df-shortcode-script');
              if(js != null){
                  js.forEach((item) => {
                      eval(item.innerHTML);
                  });
              }
          });

        barba.hooks.afterEnter((data) => {


/*
            setTimeout(function() {
                if ($('body').hasClass("home")) {
                    console.log('has home')
                    $(".home .home-button a").prop("href", "https://disarmingdesign.com/about");
                }
                if (!$('body').hasClass("home")) {
                    console.log('has no home')
                    $(".home .home-button a").prop("href", "https://disarmingdesign.com/");
                }
            }, 1000);*/


                $('.product-popup__close, .continue-shopping').on('click', function(e){
                    $('.product-popup').removeClass('active');
                });



                        if ($(".product-type-variable .variations select").val() === "") {
                            $(".button").addClass('disable');
                        }
                        else {
                            $(".button").removeClass('disable');
                        }

                        var value = $(".variations select").val();

                        $(".product-type-variable .variations select").each(function() {
                            $(this).on('change', function() {


                                let attribute = $(this).attr('data-key');
                                let option = $(this).attr('value');
                                console.log( attribute, option );
                                $('#' + attribute).val( option ).change();

                                $( document.body ).trigger( 'woocommerce_variation_has_changed' );

                                if ($("#pa_colour").val() !== "" && $("#pa_size").val() !== "" ) {
                                    $(".button").removeClass('disable');
                                }
                                else {
                                    $(".button").addClass('disable');
                                }
                            });
                        });


            $( document.body ).trigger( 'wc_fragments_loaded' );
            $( document.body ).trigger( 'check_variations' );


            $( ".single_variation_wrap" ).on( "show_variation", function ( event, variation ) {
                console.log( variation.variation_id );
                console.log( variation );
            } );


            $( document ).on( "found_variation.first", function ( e, v ) {
                console.log( v.variation_id );
                console.log( v );
            } );



            $('.single_add_to_cart_button').on('click', function(e){


                e.preventDefault();

                $('.product-popup').addClass('active');


                $( '.mini-cart').removeClass("hidden");


                $thisbutton = $(this),

                    $form = $thisbutton.closest('form.cart'),

                    id = $thisbutton.val(),

                    product_qty = $form.find('input[name=quantity]').val() || 1,

                    product_id = $form.find('input[name=product_id]').val() || id,

                    variation_id = $form.find('input[name=variation_id]').val() || 0;

                console.log(variation_id);

                var data = {

                    action: 'ql_woocommerce_ajax_add_to_cart',

                    product_id: product_id,

                    product_sku: '',

                    quantity: product_qty,

                    variation_id: variation_id,

                };

                $.ajax({

                    type: 'post',

                    url: wc_add_to_cart_params.ajax_url,

                    data: data,

                    beforeSend: function (response) {

                        $thisbutton.removeClass('added').addClass('loading');

                    },

                    complete: function (response) {

                        $thisbutton.addClass('added').removeClass('loading');
                    },

                    success: function (response) {

                        if (response.error & response.product_url) {

                            window.location = response.product_url;

                            return;

                        } else {

                            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

                        }

                    },

                });

            });

            $(".mobile-menu").removeClass("show-mobile-menu");
            $(".body-overlay").hide("fast");

            $('.slider-normal-bottom').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                pauseOnHover: false,
                fade: true,
                lazyLoad: 'ondemand',
                speed: 2500,
                //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                autoplaySpeed: 4500,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 700
                        }
                    }
                ]
            });




            $('.slider-normal-top').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                pauseOnHover: false,
                fade: true,
                lazyLoad: 'ondemand',
                speed: 2500,
                //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                autoplaySpeed: 4000,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 700
                        }
                    }
                ]
            });

            $(document).foundation();

            about_nav();

            $('form.cart').on( 'click', 'button.plus, button.minus', function() {

                // Get current quantity values
                var qty = $( this ).closest( 'form.cart' ).find( '.qty' );
                var val   = parseFloat(qty.val());
                var max = parseFloat(qty.attr( 'max' ));
                var min = parseFloat(qty.attr( 'min' ));
                var step = parseFloat(qty.attr( 'step' ));

                // Change the value if plus or minus
                if ( $( this ).is( '.plus' ) ) {
                    if ( max && ( max <= val ) ) {
                        qty.val( max );
                    } else {
                        qty.val( val + step );
                    }
                } else {
                    if ( min && ( min >= val ) ) {
                        qty.val( min );
                    } else if ( val > 1 ) {
                        qty.val( val - step );
                    }
                }

            });


            $('.projects-link-footer .a').click(function() {
                $('.projects-link-footer').addClass('active');
            });




            $('.slider-row').slickLightbox({
                itemSelector        : 'a',
                navigateByKeyboard  : true
            });


            $('.slider-row').slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                autoplay: false,
                pauseOnHover: false,
                fade: false,
                customPaging : function(slider, i) {
                    var thumb = $(slider.$slides[i]).data();
                    return '<span class="normal">'+(i+1)+'</span>';
                },
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                           // rows: 4,
                            slidesToShow: 1,
                           slidesToScroll: 1
                        }
                    }
                ]
            });

            $('.slider-row-home').slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                autoplay: false,
                pauseOnHover: false,
                fade: false,
                customPaging : function(slider, i) {
                    var thumb = $(slider.$slides[i]).data();
                    return '<span class="normal">'+(i+1)+'</span>';
                },
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });




        });


        barba.hooks.enter(() => {



          window.scrollTo(0, 0);
        });


















        // fire initial resize
        $(window).trigger('resize');

      },
      finalize: function() {
        $(window).trigger('resize');
        // JavaScript to be fired on all pages, after page specific JS is fired

      },
      resize: function() {

        if( /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ) {
          $(".events-video-wrapper video").hide();
          $(".events-video-wrapper .video-thumbnail").show();
        }
        else {
          $(".events-video-wrapper video").show();
          $(".events-video-wrapper .video-thumbnail").hide();
        }


          function equalHeight(group) {
              var tallest = 0;
              group.css('height','auto'); //otherwise only works once!
              group.each(function() {
                  var thisHeight = $(this).height();
                  if(thisHeight > tallest) {
                      tallest = thisHeight;
                  }
              });
              group.height(tallest);
          }



          // Hoehen syncen!!
          if($(window).width() > 725){
            //  equalHeight($('.teaser-section .teaser-text'));
          //  equalHeight($('.single-slider .testimonal-quote'));
            equalHeight($('.formular-height'));
            equalHeight($('.teaser-section .teaser-headline'));
            equalHeight($('.advantage-height'));
          }
          else {


              $('.teaser-section .teaser-text').css({'height': 'auto'});
          }

        var headerHeight = $('#main-header').outerHeight(true);
        var footerHeight = $("#footer-wrap").outerHeight(true);
        var windowHeight = $(window).height();
        var combinedHeight = windowHeight - headerHeight - footerHeight;




        // Sliders
        var resizeSliders = null;

        clearTimeout(resizeSliders);
        resizeSliders = setTimeout(
          function() {
            function renderCounter(slick,carouselId) {
              var slidesToShow;
              if(slick.activeBreakpoint!==null){
                slidesToShow = slick.breakpointSettings[slick.activeBreakpoint].slidesToShow;
              } else {
                slidesToShow = slick.options.slidesToShow;
              }

              if($('#'+carouselId).parents('.slider-wrapper').find('.slick-next').length>0){
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html( (slick.currentSlide+slidesToShow)/slidesToShow +' / ' + Math.ceil((slick.slideCount)/slidesToShow));
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').show();
              } else {
                $('#'+carouselId).parents('.slider-wrapper').find('.counter').html('');
                $('#'+carouselId).parents('.slider-wrapper').find('.slider-control').hide();
              }
            }

            $('.common-slider').each(function (idx, item) {
              if ($(this).hasClass('slick-initialized')) {
                  $(this).slick('resize');
              } else {
                var carouselId = "carousel_" + idx;
                this.id = carouselId;
                $(this).attr('data-counter','carousel_slick-control_' + idx);
                $(this).next('.slider-control').attr('id','carousel_slick-control_' + idx);

                $(this).on('init', function(event, slick) {
                  //console.log('init');
                });

                $(this).on('setPosition', function(event, slick) {
                  //console.log('setPosition');
                  renderCounter(slick,carouselId);
                });

                $(this).on('afterChange', function(event, slick, currentSlide){
                  //console.log('afterChange');
                });

                $(this).on('edge', function(event, slick, direction){
                  //console.log('edge was hit');
                });

                $(this).slick();

              }
            });

          },
          400
        );


        $(".section-headline:contains(' // ')").html(function(_, html) {
          return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
        });

        // replace double slashes with icon
        function replace_slashes() {




          $(".section-headline:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });

          $("section .post-item-hover-text:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });
          $("section .post-item-hover-name:contains(' // ')").html(function(_, html) {
            return  html.replace(/\/{2,}/g, ' <span class="icon-typosign"></span> ');
          });
        }


        // Load ajax posts
        function load_ajax_posts () {
            var settingsKey = $(this).attr('data-posts-selector-index');
            var currentPostID = $(this).attr('data-posts-selector-current-post-id');

            var currentManualTeaserArray = $(this).attr('data-posts-selector-manual-teaser-array');
            var currentCategory = $(this).attr('data-posts-selector-category');
            var currentTag = $(this).attr('data-posts-selector-tag');
            var currentHowManyTeasers = $(this).attr('data-posts-selector-how-many-teasers');
            var currentNumRowsMobile = $(this).attr('data-posts-selector-num-rows-mobile');
            var currentNumRowsDesktop = $(this).attr('data-posts-selector-num-rows-desktop');

            var currentPostCount = $(this).find('.load-more').attr('data-load-more-current-post-count');
            var currentOffset = $(this).find('.load-more').attr('data-load-more-current-offset');

            var currentPostsPerPage = -1;
            var currentMediaquery = '';

            if (currentHowManyTeasers !== 'all') {
              if (Foundation.MediaQuery.is('small only')) {
                  currentPostsPerPage = currentNumRowsDesktop;
              }
              if (Foundation.MediaQuery.is('medium only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 1;
              }
              if (Foundation.MediaQuery.is('large only')) {
                  currentPostsPerPage = currentNumRowsDesktop * 1;
              }
              if (Foundation.MediaQuery.atLeast('xlarge')) {
                  currentPostsPerPage = currentNumRowsDesktop * 1;
              }
            }

            if (Foundation.MediaQuery.is('small only')) {
                currentMediaquery = 'small';
            }
            if (Foundation.MediaQuery.is('medium only')) {
                currentMediaquery = 'medium';
            }
            if (Foundation.MediaQuery.is('large only')) {
                currentMediaquery = 'large';
            }
            if (Foundation.MediaQuery.atLeast('xlarge')) {
                currentMediaquery = 'xlarge';
            }

            if (!($('.posts-selector-multiple-' + settingsKey).hasClass('loader-loading'))) {

              $.ajax({
                type: "GET",
                url: SiteParameters.ajax_url,
                dataType: 'html',
                data: ({
                  action: 'load_responsive_posts',
                  currentsettingskey: settingsKey,
                  currentpostid: currentPostID,
                  currentpostsperpage: currentPostsPerPage,
                  currentmediaquery: currentMediaquery,
                  currentmanualteaserarray: currentManualTeaserArray,
                  currentcategory: currentCategory,
                  currenttag: currentTag,
                  currentpostcount: currentPostCount,
                  currentoffset: currentOffset
                }),
                beforeSend : function () {
                  $('.posts-selector-multiple-' + settingsKey).addClass('loader-loading');
                },
                success: function(data) {
                  if(data) {
                    if ( $('#load-more-' + settingsKey).length > 0 ) {
                      $('#load-more-' + settingsKey).replaceWith(data);
                    } else {
                      $('.posts-selector-multiple-' + settingsKey).prepend(data);
                    }






                    replace_slashes();

                  } else {
                    console.log("no data");
                  }
                },
                error: function(data) {
                  console.log("Error :( " + data);
                  return false;
                },
                complete:   function() {
                  replace_slashes();

                  $('.posts-selector-multiple-' + settingsKey).removeClass('loader-loading');
                  // Trigger event after the posts are loaded
                  var loadResponsivePostsCompleteEvent = new Event('loadResponsivePostsComplete');
                  document.dispatchEvent(loadResponsivePostsCompleteEvent);
                }
              });
            }




            return false;
        }

        var resizeMorePosts = null;
        clearTimeout(resizeMorePosts);
        resizeMorePosts = setTimeout(
          function() {
            var numSlides = $('.slick-dots li').length;
            $( ".slick-dots li:last-child" ).after( '<span class="total"> / '+ numSlides +'</span>' );
            $('.slick-prev').appendTo(".slick-dots");
            $('.slick-next').appendTo(".slick-dots");

            $('.news-section .post-item-wrap').each(function(){
              $(this).remove();
            });
            $('.news-section .load-more').each(function(){
              $(this).remove();
            });
            $.each($('.posts-selector-multiple'), load_ajax_posts);
          },
          400
        );


        $(".posts-selector-multiple").on('click', 'button.load-more', function() {
          var currentParent = $(this).closest('.posts-selector-multiple');
          $.each(currentParent, load_ajax_posts);
        });

        document.addEventListener('loadResponsivePostsComplete', function(e) {
          //console.log("loadResponsivePostsComplete");
        }, false);



      },
      windowload: function() {


      }
    },
    // Home page
    'home': {
      init: function() {

        jQuery(function($) {

          var $nav = $('#main-header');
          var $win = $(window);
          var winH = $win.height();

          $win.on("scroll", function () {
            if ($(this).scrollTop() > winH ) {
              $nav.addClass("teaser-header");
            } else {
              $nav.removeClass("teaser-header");
            }
          }).on("resize", function(){
            winH = $(this).height();
          });

        });
        // JavaScript to be fired on the home page


        // open popup and scroll to selected slide
        $('.portfolio-link-internal').click(function(){
              var slide_id = $(this).attr('data-indexnum');
              $("#bullet"+ slide_id).click();
              $('#portfolioModal').foundation('open');
            $('#portfolioModal').toggleClass('open');
              console.log(slide_id);
              return false;
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

      },
      resize: function() {





      },
      windowload: function() {

      }
    },
    'page_template_template_layouts': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      },
      windowload: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        //UTIL.fire(classnm, 'resize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
      //UTIL.fire('common','resize');
    },
    resizeEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'resize');
      });

      UTIL.fire('common','resize');

    },
    windowLoadEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm, 'windowload');
      });

      UTIL.fire('common','windowload');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  $(window).on("load",UTIL.windowLoadEvents);

  // Resize Events
  var trackWindowWidth = $(window).width();

  $(window).resize(function (trackResizeEvent) {
      //console.log(!trackResizeEvent.isTrigger ? ' resize' : ' triggerd');

      // Check window width has actually changed and it's not just iOS triggering a resize event on scroll || the resize event was caused by $(window).trigger('resize');
      if (($(window).width() !== trackWindowWidth) || trackResizeEvent.isTrigger) {
          // Update the window width for next time
          trackWindowWidth = $(window).width();

          UTIL.resizeEvents();
      }
  });


})(jQuery); // Fully reference jQuery after this point.

